export default __webpack_public_path__ + "maps-examples-approximate-location-thumbnail-960-55fd102c15d3b61025c95b5f5e959df5.png";